import storage from '../utils/storage'
// import watermark from 'watermark-dom'

const initUser = {
  username: storage.get('username') || '',
  token: storage.get('token') || '',
}

const initMeta = {
  envs: [],
  permissions: [],
}

const initIds = {
  gid: storage.get('gid') || '',
  pid: storage.get('pid') || '',
}

const initNames = {
  gname: storage.get('gn') || '',
  pname: storage.get('pn') || '',
  nname: storage.get('nn') || '',
}

export const user = {
  state: initUser,
  reducers: {
    update(state: any, payload: any) {
      state.username = payload.username
      state.token = payload.token
      storage.set('username', payload.username)
      storage.set('token', payload.token)
      // http.defaults.headers.Authorization = `Bearer ${payload.token}`
      return state
    },
    logout(state: any, payload: any) {
      storage.clear()
      // storage.remove('username')
      // storage.remove('token')
      state.username = ''
      state.token = ''
      // watermark.remove()
      return state
    },
  },
}

export const meta = {
  state: initMeta,
  reducers: {
    update(state: any, payload: any) {
      state.envs = payload.env
      state.permissions = payload.namespacePermissions
      return state
    },
  },
}

export const ids = {
  state: initIds,
  reducers: {
    update(state: any, payload: any) {
      if (payload.gid) {
        state.gid = payload.gid
        storage.set('gid', payload.gid)
      }
      if (payload.pid) {
        state.pid = payload.pid
        storage.set('pid', payload.pid)
      }
      return state
    },
  },
}

export const names = {
  state: initNames,
  reducers: {
    update(state: any, payload: any) {
      if (payload.gname) {
        state.gname = payload.gname
        storage.set('gn', payload.gname)
      }
      if (payload.pname) {
        state.pname = payload.pname
        storage.set('pn', payload.pname)
      }
      if (payload.nname) {
        state.nname = payload.nname
        storage.set('nn', payload.nname)
      }
      return state
    },
  },
}
